import { useEffect } from "react";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import NextLink from "next/link";
import Head from "next/head";
import { useRouter } from "next/compat/router";
import { Heading, Box, Link, IconFa } from "@cruk/cruk-react-components";

import { useSwrGet } from "@fwa/src/hooks/useSwrGet";
import { queryAsString } from "@fwa/src/utils/urlUtils";
import { fwsUrlTeamSlug } from "@fwa/src/services/teamService";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";

import { ErrorPageWrapper } from "@fwa/src/components/ErrorPageWrapper";
import { TeamLeaderboardListPaginated } from "@fwa/src/components/LeaderboardListPaginated";

import sharedStyles from "@fwa/src/components/styles.module.css";

import { type BrandNameType, type TeamPageType } from "@fwa/src/types";
import { getBrandForPage } from "@fwa/src/utils/pageUtils";

export const TeamLeaderboardPage = () => {
  const router = useRouter();
  const { slug } = router?.query || {};
  const slugString = queryAsString(slug);
  const urlOrNull = slugString.length
    ? fwsUrlTeamSlug({ slug: slugString })
    : null;
  const { data: teamPage, error } = useSwrGet<TeamPageType>(urlOrNull);

  const themeName = teamPage
    ? teamPage?.theme || getBrandForPage(teamPage)
    : null;
  const [brandName, setBrandName] = useBrandContext();
  useEffect(() => {
    if (!!themeName && themeName !== brandName) {
      setBrandName(themeName as BrandNameType);
    }
  }, [themeName, brandName, setBrandName]);

  return (
    <ErrorPageWrapper error={error || undefined}>
      {teamPage ? (
        <>
          <Head>
            <title>{`${teamPage.title} leaderboard`}</title>
          </Head>
          <div className={sharedStyles["content-max-width"]}>
            <Box backgroundColor="background-light" padding="s" marginTop="m">
              <NextLink
                href={`/team${teamPage.url.slice(teamPage.url.lastIndexOf("/"))}`}
                data-cta-type="link-team"
              >
                <Link appearance="secondary" as="span">
                  <IconFa faIcon={faCaretLeft} size="s" />
                  Back to team page
                </Link>
              </NextLink>
            </Box>
            <Box backgroundColor="background-light" padding="s" marginTop="m">
              <Heading h1>Team Leaderboard</Heading>
              <Box>
                {/* leaderboard block */}
                <TeamLeaderboardListPaginated
                  page={teamPage}
                  memberType="page"
                />
              </Box>
            </Box>
          </div>
        </>
      ) : null}
    </ErrorPageWrapper>
  );
};

export default TeamLeaderboardPage;
